<div mat-dialog-title>
  <span>View PPA</span>
  <button [mat-dialog-close]="false" mat-icon-button><mat-icon>close</mat-icon></button>
</div>
<div mat-dialog-content class="pdf-container">
  <ng2-pdfjs-viewer #pdfViewerOnDemand [externalWindow]="false" [downloadFileName]="'receipt.pdf'" [openFile]="false"
    [viewBookmark]="false" [download]="false" [print]="false">
  </ng2-pdfjs-viewer>
</div>